<div
  class="container"
  (mouseenter)="onMouseLeave()"
  [ngClass]="{ externalDrag: externalDrag, dragging: dragging, disableDrag: disableDrag }"
>
  <img
    *ngIf="item"
    id="visionboard-workspace-item-image-{{ item.internalId }}"
    class="image"
    src="{{ item.visionboardThumbnail }}"
    imgErrLog
  />
  <button
    *ngIf="removable"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    mat-icon-button
    class="remove-button"
    (click)="onRemoveClick()"
    disableRipple
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
